module.exports = __webpack_public_path__ + "static/img/t1.f04731f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/founderIntr/img/zh/t1.jpg
// module id = TWSF
// module chunks = 5